// extracted by mini-css-extract-plugin
export default {"button":"Button_button__yKNSV","button--inverse":"Button_button--inverse__Bl08I"};